var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuDataSynchronization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.32,
    height: 18.32,
    viewBox: "0 0 18.32 18.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M19.4,18.488H3.832V2.916A.916.916,0,1,0,2,2.916V19.4a.916.916,0,0,0,.916.916H19.4a.916.916,0,0,0,0-1.832Z",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M7.832,15.824v-4.58a.916.916,0,0,0-1.832,0v4.58a.916.916,0,0,0,1.832,0Zm3.664,0V7.58a.916.916,0,0,0-1.832,0v8.244a.916.916,0,0,0,1.832,0Zm3.664,0V5.748a.916.916,0,0,0-1.832,0V15.824a.916.916,0,0,0,1.832,0Zm3.664,0V3.916a.916.916,0,0,0-1.832,0V15.824a.916.916,0,0,0,1.832,0Z",
    transform: "translate(-0.336 -0.084)",
    fill: "#afafaf"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDataSynchronization);
export default __webpack_public_path__ + "static/media/icon-menu-data-synchronization.6162905b50cd6119fcdd6dec994ae603.svg";
export { ForwardRef as ReactComponent };